export default function Products() {
  const products = [
    {
      name: 'iPhone 17',
      price: 'NT$ 29,900',
      image: 'https://static.readdy.ai/image/97c793d11ca453c3d5eaa5489729c4a4/b615a64527fa92180ea97436d6d61bf7.jpeg',
      bgColor: 'bg-gradient-to-br from-blue-50 to-teal-50',
      featured: true
    },
    {
      name: 'iPhone 17 Pro',
      price: 'NT$ 39,900',
      image: 'https://static.readdy.ai/image/97c793d11ca453c3d5eaa5489729c4a4/1d93a5f3f23f81d19da555fcdadb1a09.jpeg',
      bgColor: 'bg-gradient-to-br from-gray-50 to-slate-50',
      featured: false
    },
    {
      name: 'iPhone 17 Pro Max',
      price: 'NT$ 42,900',
      image: 'https://static.readdy.ai/image/97c793d11ca453c3d5eaa5489729c4a4/1d93a5f3f23f81d19da555fcdadb1a09.jpeg',
      bgColor: 'bg-gradient-to-br from-gray-50 to-zinc-50',
      featured: false
    }
  ];

  return (
    <section id="products" className="py-24 bg-gray-50" data-product-shop>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <h2 className="text-5xl font-light text-gray-900 mb-3">本月熱銷機種</h2>
          <p className="text-sm text-gray-500">精選三款最受歡迎的智慧型手機</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer"
              data-product-shop
            >
              <div className={`${product.bgColor} rounded-3xl p-8 mb-6 flex items-center justify-center`} style={{ minHeight: '320px' }}>
                <div className="w-full h-64">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain object-center transform hover:scale-105 transition-transform duration-300"
                  />
                </div>
              </div>

              <h3 className="text-xl font-medium text-gray-900 text-center mb-2">
                {product.name}
              </h3>
              <p className="text-3xl font-bold text-teal-600 text-center mb-6">
                {product.price}
              </p>

              <button className={`w-4/5 mx-auto block py-3.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                product.featured
                  ? 'bg-black text-white hover:bg-gray-900'
                  : 'bg-white text-black border-2 border-black hover:bg-gray-50'
              }`}>
                {product.featured ? '立即購買' : '查看詳情'}
              </button>

              <p className="text-xs text-gray-400 text-center mt-4">含稅價 | 現貨供應</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
